import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Toaster } from "sonner";
import { captureAttribution } from "./lib/attribution";
import { Nav } from "./components/Nav";
import { ParallaxDivider } from "./components/ParallaxDivider";
import Hero from "./sections/Hero";
import { Ticker, Manifesto, Letter } from "./sections/MidSections";
import { Audience, Roadmap, Curriculum } from "./sections/LearnSections";
import HostSection from "./sections/HostSection";
import { Transformation, Takeaways, FAQ } from "./sections/LaterSections";
import { FinalRegister, Footer, MobileCTA } from "./sections/Closing";
import { LuxuryStrip } from "./sections/LuxuryStrip";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Replay from "./pages/Replay";

gsap.registerPlugin(ScrollTrigger);

const Landing = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Ticker />
      <Manifesto />
      <Letter />
      <ParallaxDivider />
      <Audience />
      <Roadmap />
      <LuxuryStrip />
      <Curriculum />
      <HostSection />
      <Transformation />
      <Takeaways />
      <FAQ />
      <FinalRegister />
      <Footer />
    </main>
    <MobileCTA />
  </>
);

function App() {
  useEffect(() => {
    captureAttribution();
    const lenis = new Lenis({ lerp: 0.09 });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/replay" element={<Replay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="light" richColors />
    </div>
  );
}

export default App;
